import { UNAUTHORIZED } from '../libraries/texts';

const unAuthorized = props => {
  return UNAUTHORIZED;
};

export default unAuthorized;
